/* tslint:disable */
/* eslint-disable */
export enum WorkTodoPriorityEnum {
  Low = 'low',
  Medium = 'medium',
  High = 'high'
}
